var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.company.company_type === 'RESTAURANT' || _vm.$store.state.choicedCompany.company_type === 'RESTAURANT')?_c('HomeFood'):_c('HomeWhiteLabel')}
var staticRenderFns = []

export { render, staticRenderFns }